
import DashboardLayout from "../layoutcontainers/DashboardLayout"
const ProfileTable = ()=>{


    return(
    
        <DashboardLayout>

            
        </DashboardLayout> 


    )
}
export default ProfileTable